import { DefaultOptionType } from 'antd/es/select';
import React, { FC, memo, useCallback, useMemo } from 'react';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { Select } from 'shared/ui/Select';
import { BoxNoteFilter, BoxesListFilterKeys } from '../../model/types';

interface BoxNoteSelectProps {
  value: string;
  onChange: (value: string, label: string) => void;
  onClear: (filterKey: string) => void;
}

export const BoxNoteSelect: FC<BoxNoteSelectProps> = memo((props) => {
  const { value, onChange, onClear } = props;

  const { t } = useAppTranslation('boxes');

  const boxNoteSelectOptions = useMemo<Array<{ label: string; value: BoxNoteFilter }>>(() => {
    return [
      { label: t('With notes'), value: BoxNoteFilter.HAS_NOTES },
      { label: t('Without notes'), value: BoxNoteFilter.WITHOUT_NOTES },
    ];
  }, [t]);

  const handleChange = useCallback(
    (value: string, option?: DefaultOptionType | DefaultOptionType[]): void => {
      if (!Array.isArray(option) && typeof option?.label === 'string') {
        onChange(value, option.label);
      }
    },
    [onChange],
  );

  const clearFilter = useCallback(() => {
    onClear(BoxesListFilterKeys.hasNotes);
  }, [onClear]);

  return (
    <Select
      containerClassName="flex-1"
      className="w-full"
      label={t('Note')}
      placeholder={t('All')}
      bordered
      allowClear
      options={boxNoteSelectOptions}
      value={value}
      onChange={handleChange}
      onClear={clearFilter}
    />
  );
});
